import React, { useContext, useEffect, useState } from "react"

import EventEmitter from "src/EventEmitter"

import ModalWithProvidedBody from "components/ModalWithProvidedBody"

import CloudroomContext from "../CloudroomContext"

const MissingTutorModal = () => {
  const { session, localUser, roster } = useContext(CloudroomContext)

  const [missingTutor, setMissingTutor] = useState<boolean>(
    session.missingTutor
  )

  useEffect(() => {
    if (localUser.type !== "Student") return

    const onMissingTutor = () => setMissingTutor(true)
    EventEmitter.subscribe("missing_tutor", onMissingTutor)

    const closeModal = () => setMissingTutor(false)
    // make sure this modal closes in these cases too
    EventEmitter.subscribe("session_canceled", closeModal)
    EventEmitter.subscribe("session_reassignment", closeModal)

    return () => {
      EventEmitter.unsubscribe("missing_tutor", onMissingTutor)
      EventEmitter.unsubscribe("session_canceled", closeModal)
      EventEmitter.unsubscribe("session_reassignment", closeModal)
    }
  }, [localUser.type])

  useEffect(() => {
    const tutorPresent = Object.values(roster).some((participant: any) =>
      participant.externalUserId.includes("Tutor")
    )
    if (tutorPresent && missingTutor) setMissingTutor(false)
  }, [roster, missingTutor])

  if (!missingTutor) return null
  return (
    <ModalWithProvidedBody
      isOpen
      hideTrigger
      modalClassName="bootstrap-modal"
      modalTitle="Please wait, session will begin soon"
      hideCloseButton
    >
      <>
        <div className="modal-body">
          <p className="lead">
            Your tutor is running late. Please wait while we contact them or
            find a replacement for your session.
          </p>
        </div>
      </>
    </ModalWithProvidedBody>
  )
}

export default MissingTutorModal
